import styled from 'styled-components/macro';
import modularScale from 'styles/helpers/modular-scale';

/**
 * The Layout component defines a set of layout helpers you can access by using dot notation in JSX.
 */
const MaxWidth = styled.div<any>`
  width: ${({ theme, isNewDesign }: any): number =>
    isNewDesign ? 100 : theme.layout.smallScreen * 100}%;
  max-width: ${({ isNewDesign, browseRelated }): string =>
    isNewDesign
      ? '100% !important'
      : `calc(100% - ${modularScale(0)} * ${browseRelated ? 3 : 2})`};
  margin: 0 auto;
  align-self: center;

  position: ${({ relative }): any => relative && 'relative'};

  @media screen and (min-width: 80em) {
    width: ${({ theme, isWide, topList }): number =>
      topList ? 81 : isWide ? 100 : theme.layout.largeScreen * 100}%;
    max-width: ${({ isWide, browseRelated }): string =>
      isWide
        ? 'calc(100% - (2em * 2))'
        : `calc(100% - (${modularScale(0)} * ${browseRelated ? 3 : 2}))`};
  }
  ${({ isNarrowScreen, browseRelated }): string =>
    isNarrowScreen
      ? `
      @media screen and (max-width: 50em) {
        width: 100% !important;
        max-width: calc(100% - (0.5em * ${browseRelated ? 3 : 2}));
      }
      @media screen and (min-width: 40em) {
        width: 100%;
        max-width: 100%;
        padding: 0 2em;
      }
      `
      : ''}
  ${({ isMobileWide }): string =>
    isMobileWide
      ? `
        @media screen and (max-width: 800px) {
          width: 100%;
          margin: 1em auto;
        }
        @media screen and (max-width: 751px) {
          margin: 0.5em auto;
          max-width: calc(100% - 1em);
        }
        @media screen and (max-width: 640px) {
          max-width: 100%;
        }
        `
      : ''}
      ${({ topList }): string =>
        topList && 'width: fit-content; max-width: initial;'}
`;

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Relative = styled.div`
  position: relative;
`;

const AlignRight = styled.div`
  display: flex;
  justify-content: flex-end;
`;

/**
 * @component
 */
export default { AlignRight, Center, MaxWidth, Relative };
